import { namedMemo } from '@/utils/namedMemo';
import { EnumCellProps, WithClassname } from '@jsonforms/core';
import merge from 'lodash/merge';
import { Select } from '@chakra-ui/react';
import React from 'react';
import { useWorkplan } from '@/components/contexts/WorkplanContext/useWorkplan';

export const CurrentYearSelect = namedMemo('CurrentYearSelect', (props: EnumCellProps & WithClassname) => {
    const { data, config, id, enabled, uischema, path, handleChange } = props;
    const appliedUiSchemaOptions = merge({}, config, uischema.options);

    const currentYear = new Date().getFullYear();

    const { workplan } = useWorkplan();
    const startYear = +(workplan?.year ?? currentYear);
    const years = +(uischema?.options?.['years'] ?? 3) + 1;

    return (
        <Select
            id={id}
            value={data ?? ''}
            isReadOnly={!enabled}
            disabled={!enabled}
            autoFocus={appliedUiSchemaOptions.focus}
            placeholder={appliedUiSchemaOptions.placeholder}
            onChange={(ev) => handleChange(path, ev.target.value)}
            role="combobox"
        >
            {new Array(years).fill(0).map((_, i) => (
                <option key={i} value={startYear + i} style={{ background: 'unset' }}>
                    {startYear + i}
                </option>
            ))}
        </Select>
    );
});
